
import React, {useEffect, useState} from "react"


export const HoveredButton = React.memo(({ step, type, handleNext, className='',rounded='rounded-full', onClick=undefined, text='Suivant' }:any) => {
    const [hover, setHover] = useState(false)
    console.log({hover})
    return (
      <div 
        className={`relative inline-block p-[.15rem] ${rounded} bg-gradient-to-r from-[#805ad5] via-[#d53f8c] to-[#ed8936]`}
      >
        <button 
          type={'button'} 
          onClick={onClick}  
          form={`form-step${step}`} 
          className={`w-full h-full px-6 font-bold ${rounded} py-1 ${className}`}
        >
          <div className={`bg-clip-text bg-gradient-to-r from-[#805ad5] via-[#d53f8c] to-[#ed8936] text-transparent `}>
            {text}
          </div>  
        </button>
      </div>
    )
    
  })